import React, { useEffect, useState } from "react";
import UserBids from "./components/UserBids";
import carousalData from "../../data/personCarousalmock";
import Navbar from "../../components/Navbar";
import { Container, Typography, Stack, Grid } from "@mui/material";
import ShowRouting from "../../components/ShowRouting";
import Footer from "../../components/Footer";
import BidsSkeleton from "./components/BidsSkeleton";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import SelectedRequest from "./components/SelectedRequest";
import { Link } from "react-router-dom";
import { getBids } from "../../apis";

const ReceivedBids = () => {
  const navigate = useNavigate();
  const [bids, setBids] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedRequest, setSelectedRequest] = useState(null);

  useEffect(() => {
    let user = {};
    user = JSON.parse(localStorage.getItem("user-info"));
    let fetchData = async () => {
      let response = await getBids(user.googleId ? user.googleId : user._id);
      setBids(response.data.bids);
      if (response.data) {
        setLoading(false);
      }
    };

    if (_.isEmpty(user)) {
      navigate("/login");
    }

    fetchData();
  }, []);

  const RequestClickhandler = (id) => {
    const filteredResult = bids.filter((item) => item._id == id);
    setSelectedRequest(filteredResult[0]);
  };

  return (
    <>
      <Navbar />
      <Grid container>
        <Grid item sm={6}>
          <Container>
            <Typography
              variant="h5"
              gutterBottom
              component="div"
              style={{ paddingLeft: "70px", paddingTop: "20px" }}
            >
              Received Quotes
            </Typography>

            {loading && (
              <div
                style={{
                  border: "1px solid #EEEBEF",
                  borderRadius: "6px",
                  paddingLeft: "70px",
                }}
                className="mb-16"
              >
                <BidsSkeleton />
                <BidsSkeleton />
                <BidsSkeleton />
                <BidsSkeleton />
                <BidsSkeleton />
              </div>
            )}
            <div style={{ paddingLeft: "70px" }}>
              <div
                style={{
                  border: "1px solid #EEEBEF",
                  borderRadius: "6px",
                }}
                className="mb-16"
              >
                <Stack spacing={2}>
                  {bids.length && loading == false ? (
                    bids.map((item) => (
                      <UserBids bid={item} clickHandler={RequestClickhandler} />
                    ))
                  ) : (
                    <Typography>No bids to show</Typography>
                  )}
                </Stack>
              </div>
            </div>
          </Container>
        </Grid>
        <Grid item sm={6}>
          {selectedRequest != null ? (
            <SelectedRequest currentRequest={selectedRequest} />
          ) : null}
        </Grid>
      </Grid>
      <Footer />
    </>
  );
};

export default ReceivedBids;
